<template>
  <div>
    <div>
      <el-row :gutter="10">
        <el-col :xs="24" :lg="6" style="margin: 6px 0">
          <span>企业名称：</span>
          <el-input
            style="width: 180px"
            size="mini"
            v-model="Qname"
            placeholder="请输入"
          ></el-input>
        </el-col>

        <el-col :xs="24" :lg="6">
          <span>行业名称：</span>
          <el-select
            v-model="industryName"
            placeholder="请选择"
            @change="getShowData1"
            size="mini"
          >
            <el-option
              v-for="item in industryList"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-col>

        <el-col :xs="24" :lg="6" style="margin: 6px 0">
          <span>区县名称：</span>
          <el-select
            v-model="dataDistrict"
            placeholder="请选择"
            @change="getShowData"
            size="mini"
          >
            <el-option
              v-for="item in seatList"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :xs="24" :lg="6">
          <span style="margin-left: 24px">时间：</span>
          <el-date-picker
            class="jiance_phone_date"
            :editable="false"
            :clearable="false"
            v-model="times"
            type="month"
            value-format="yyyy-MM"
            size="mini"
            :picker-options="pickerOptions"
            @change="monthChange"
            placeholder="选择月"
          ></el-date-picker>
        </el-col>
      </el-row>
      <el-row style="margin: 10px 0 20px" align="center">
        <div class="phone_button">
          <el-button type="primary" style="mini" @click="search"
            >查询</el-button
          >
          <el-button type="info" style="mini" @click="reset">重置</el-button>
        </div>
      </el-row>
    </div>
    <el-link style="margin: 10px 0px" type="primary" @click="exportData">{{
      exportLabel
    }}</el-link>
    <div>
      <el-row style="margin: 10px 0px">
        <el-col :span="24">
          <el-table
            v-loading="loading"
            border
            :height="tableData.length > 0 ? 420 : 180"
            :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
            stripe
            :data="tableData"
          >
            <el-table-column
              type="index"
              label="序号"
              fixed
              width="50"
            ></el-table-column>
            <el-table-column
              prop="name"
              fixed
              label="企业名称"
            ></el-table-column>

            <el-table-column :label="`工业总产值${unitStr}`">
              <el-table-column
                sortable
                :formatter="handelFix2"
                min-width="100"
                prop="monthThis1"
                label="当期"
              ></el-table-column>
              <el-table-column
                sortable
                min-width="120"
                :formatter="handelFix2"
                prop="monthLast1"
                label="上年同期"
              ></el-table-column>
              <el-table-column
                sortable
                :formatter="handelFix1"
                min-width="120"
                prop="prop1"
                label="同比增速(%)"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.prop1 }}</span>
                  <span v-if="scope.row.alert1 == 0">
                    <span
                      style="
                        display: inline-block;
                        height: 10px;
                        width: 10px;
                        background: #ffffff;
                        border-radius: 50%;
                        margin-left: 6px;
                      "
                    ></span>
                  </span>
                  <span v-if="scope.row.alert1 == 1">
                    <span
                      style="
                        display: inline-block;
                        height: 10px;
                        width: 10px;
                        background: #ffd700;
                        border-radius: 50%;
                        margin-left: 6px;
                      "
                    ></span>
                  </span>
                  <span v-if="scope.row.alert1 == 2">
                    <span
                      style="
                        display: inline-block;
                        height: 10px;
                        width: 10px;
                        background: #ff7f00;
                        border-radius: 50%;
                        margin-left: 6px;
                      "
                    ></span>
                  </span>
                  <span v-if="scope.row.alert1 == 3">
                    <span
                      style="
                        display: inline-block;
                        height: 10px;
                        width: 10px;
                        background: #f00;
                        border-radius: 50%;
                        margin-left: 6px;
                      "
                    ></span>
                  </span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column :label="`工业销售产值${unitStr}`">
              <el-table-column
                sortable
                :formatter="handelFix2"
                min-width="100"
                prop="monthThis2"
                label="当期"
              ></el-table-column>
              <el-table-column
                sortable
                min-width="120"
                :formatter="handelFix2"
                prop="monthLast2"
                label="上年同期"
              ></el-table-column>
              <el-table-column
                sortable
                :formatter="handelFix1"
                min-width="120"
                prop="prop2"
                label="同比增速(%)"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.prop2 }}</span>
                  <span v-if="scope.row.alert2 == 0">
                    <span
                      style="
                        display: inline-block;
                        height: 10px;
                        width: 10px;
                        background: #ffffff;
                        border-radius: 50%;
                        margin-left: 6px;
                      "
                    ></span>
                  </span>
                  <span v-if="scope.row.alert2 == 1">
                    <span
                      style="
                        display: inline-block;
                        height: 10px;
                        width: 10px;
                        background: #ffd700;
                        border-radius: 50%;
                        margin-left: 6px;
                      "
                    ></span>
                  </span>
                  <span v-if="scope.row.alert2 == 2">
                    <span
                      style="
                        display: inline-block;
                        height: 10px;
                        width: 10px;
                        background: #ff7f00;
                        border-radius: 50%;
                        margin-left: 6px;
                      "
                    ></span>
                  </span>
                  <span v-if="scope.row.alert2 == 3">
                    <span
                      style="
                        display: inline-block;
                        height: 10px;
                        width: 10px;
                        background: #f00;
                        border-radius: 50%;
                        margin-left: 6px;
                      "
                    ></span>
                  </span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column :label="`企业用电量（万千瓦时）`">
              <el-table-column
                sortable
                :formatter="handelFix2"
                min-width="100"
                prop="monthThis3"
                label="当期"
              ></el-table-column>
              <el-table-column
                sortable
                min-width="120"
                :formatter="handelFix2"
                prop="monthLast3"
                label="上年同期"
              ></el-table-column>
              <el-table-column
                sortable
                :formatter="handelFix1"
                min-width="120"
                prop="prop3"
                label="同比增速(%)"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.prop3 }}</span>
                  <span v-if="scope.row.alert3 == 0">
                    <span
                      style="
                        display: inline-block;
                        height: 10px;
                        width: 10px;
                        background: #ffffff;
                        border-radius: 50%;
                        margin-left: 6px;
                      "
                    ></span>
                  </span>
                  <span v-if="scope.row.alert3 == 1">
                    <span
                      style="
                        display: inline-block;
                        height: 10px;
                        width: 10px;
                        background: #ffd700;
                        border-radius: 50%;
                        margin-left: 6px;
                      "
                    ></span>
                  </span>
                  <span v-if="scope.row.alert3 == 2">
                    <span
                      style="
                        display: inline-block;
                        height: 10px;
                        width: 10px;
                        background: #ff7f00;
                        border-radius: 50%;
                        margin-left: 6px;
                      "
                    ></span>
                  </span>
                  <span v-if="scope.row.alert3 == 3">
                    <span
                      style="
                        display: inline-block;
                        height: 10px;
                        width: 10px;
                        background: #f00;
                        border-radius: 50%;
                        margin-left: 6px;
                      "
                    ></span>
                  </span>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <div class="pageBox">
        <el-pagination
          class="pagePC"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="20"
          layout="total,  prev, pager, next"
          :total="total"
        >
        </el-pagination>
        <van-pagination
          class="pagePhone"
          v-model="currentPage"
          :total-items="total"
          :items-per-page="20"
          :show-page-size="3"
          @change="changePage"
          force-ellipses
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { export2Excel } from "@/utils/utils";
export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      currentPage: 1,
      pageSize: 20,
      page: 1,
      total: 0,
      exportLabel: "<<点击此处可导出报表",
      dataDistrict: "",
      industryName: "",
      Qname: "",
      times: "",
      unitStr: "（亿元）",
      tableData: [],
      loading: false,
      industryList: [],
    };
  },
  components: {},
  computed: {
    ...mapGetters({
      seatList: "getAreaLists",
      seatList1: "getAreaListArr",
    }),
  },
  watch: {},
  methods: {
    //获取行业类型
    getIndustryNum() {
      this.$axios
        .get(`/business/upgrade/risk/selectIndustryType`)
        .then((res) => {
          this.industryList = res.data.data;
        });
    },
    reset() {
      // this.times = "";
      this.dataDistrict = "";
      this.industryName = "";
      this.Qname = "";
    },
    search(pageSize, num) {
      this.loading = true;
      let Data = {
        time: this.times,
        district: this.dataDistrict,
        companyName: this.Qname,
        industryName: this.industryName,
      };
      this.$emit("getData", Data);
      this.$axios
        .get(
          `/business/upgrade/risk/selectGenerateBusiness?dateRange=${this.times}&district=${this.dataDistrict}&industryName=${this.industryName}&companyName=${this.Qname}&pageNum=${this.page}&pageSize=${this.pageSize}`
        )
        .then((res) => {
          this.loading = false;
          this.tableData = res.data.data.list;
          this.total = res.data.data.total;
        });
    },
    monthChange() {},
    getShowData() {},
    getShowData1() {},
    handleSizeChange(val) {
      this.pageSize = val;
      this.search(this.pageSize, this.page);
    },
    changePage() {
      this.page = this.currentPage;
      this.search(this.pageSize, this.page);
    },
    handleCurrentChange(val) {
      //跳转页
      this.page = val;
      this.search(this.pageSize, this.page);
    },
    handelFix1(row, column) {
      if (!isNaN(row[column.property])) {
        return row[column.property].toFixed(1);
      } else {
        return row[column.property];
      }
    },
    handelFix2(row, column) {
      if (!isNaN(row[column.property])) {
        return row[column.property].toFixed(2);
      } else {
        return row[column.property];
      }
    },
    exportData() {
      this.$axios
        .get(
          `/business/upgrade/risk/selectCompanyFunds?dateRange=${this.times}&district=${this.dataDistrict}&pageNum=${this.page}&pageSize=100000`
        )
        .then((res) => {
          this.tableData = res.data.data.list;
          let column = [
            {
              title: "企业名称",
              key: "name",
              rowspan: 2,
            },
            {
              title: "工业总产值" + this.unitStr,
              data: [
                {
                  title: "当期",
                  toFixed: 2,
                  key: "monthThis1",
                },
                {
                  title: "上年同期",
                  toFixed: 2,
                  key: "monthLast1",
                },
                {
                  title: "同比增速(%)",
                  toFixed: 1,
                  key: "prop1",
                },
              ],
              colspan: 3,
            },
            {
              title: "工业销售产值" + this.unitStr,
              data: [
                {
                  title: "当期",
                  toFixed: 2,
                  key: "monthThis2",
                },
                {
                  title: "上年同期",
                  toFixed: 2,
                  key: "monthLast2",
                },
                {
                  title: "同比增速(%)",
                  toFixed: 1,
                  key: "prop2",
                },
              ],
              colspan: 3,
            },

            {
              title: "企业用电量（万千瓦时）",
              data: [
                {
                  title: "当期",
                  toFixed: 2,
                  key: "monthThis3",
                },
                {
                  title: "上年同期",
                  toFixed: 2,
                  key: "monthLast3",
                },
                {
                  title: "同比增速(%)",
                  toFixed: 1,
                  key: "prop3",
                },
              ],
              colspan: 3,
            },
          ];

          export2Excel(column, this.tableData, "企业风险监测");
        });
    },
  },
  created() {
    var today = new Date();
    var month = today.getMonth() + 1; //getMonth返回0-11

    var year = today.getFullYear(); //getMonth返回0-11
    this.year = year;
    this.yearDef = year;
    if (month < 10) {
      this.times = year + "-0" + month;
    } else {
      this.times = year + "-" + month;
    }
    this.getIndustryNum();
  },
  mounted() {
    this.search(1, 20);
    this.getIndustryNum();
  },
};
</script>
<style lang="less" scoped>
.phone_button {
  display: block;
  width: 150px;
  margin: 0px auto;
}
.pagePhone {
  display: none;
}
@media (max-width: 1200px) {
  .pagePC {
    display: none;
  }
  .pagePhone {
    display: flex;
  }
}
</style>